import './stylesheets/App.css';
import './stylesheets/Billing.css';
import "./stylesheets/investorCardWrapper.css";
import "./stylesheets/investorCard.css";
import { React} from 'react';
import CardWrapper from './components/investorCardsWrapper';
import { BrowserRouter as Router, Route, useHistory } from "react-router-dom";
import Account from './components/Billing/Account';
import SignOut from './components/LoginAuthentication/signOut';
import Prices from './components/Billing/Prices';
import AddCards from './components/Billing/AddCards';
import LandingPage from './components/landingPage';
import LoginPage from './components/LoginAuthentication/loginPage';
import { AuthProvider } from "./contexts/AuthContext"
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { BackendServerURL } from './constants';
import CustomRoute from './components/CustomRoute';
import WaitlistForm from './components/waitlistForm';
import SubscribtionPage from './components/Billing/SubscribtionPage';

const errorLink = onError(({ graphqlErrors, networkError }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message, location, path }) => {
      alert(`Graphql error ${message}`);
    });
  }
});

const link = from([
  errorLink,
  new HttpLink({ uri: BackendServerURL + "/graphql" }),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,
});


function App() {
  return (
    <ApolloProvider client={client}>
      <div className="App">
        <header className="App-header">
          <AuthProvider>
            <Router history={useHistory()}>
                <CustomRoute path="/login" component={LoginPage}/>
                <CustomRoute path="/" exact component={LandingPage} />
                <CustomRoute path="/waitlist" component={WaitlistForm}/>
                <CustomRoute path="/dashboard" component={CardWrapper} private black/>
                <CustomRoute path="/prices" component={Prices}/>
                <CustomRoute path="/subscribe" component={SubscribtionPage} private black/>
                <CustomRoute path="/add-card" component={AddCards} private black/>
                <CustomRoute path="/cards" component={Account} private black/>
                <CustomRoute path="/signout" component={SignOut} private/>
            </Router>
          </AuthProvider>
        </header>
      </div>
    </ApolloProvider>
  )
}

export default App;



